var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerXconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4032",
    "data-name": "Group 4032",
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.002,
    height: 41.805,
    viewBox: "0 0 144.002 51.805",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(24.903 39.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M68.838,103.435h1.446l3.459,9.423H72.285l-.736-2.014H67.573l-.723,2.014H65.379Zm-.774,6.067h2.995l-1.5-4.131Z",
    transform: "translate(-65.379 -103.306)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M99.985,109.8h1.445v.091a1.552,1.552,0,0,0,1.652,1.6,1.4,1.4,0,0,0,1.6-1.42c0-.955-.955-1.3-2-1.7-1.239-.478-2.543-1.072-2.543-2.75a2.6,2.6,0,0,1,2.892-2.517c1.833,0,2.969.981,2.956,2.736h-1.382v-.1c0-.9-.594-1.407-1.562-1.407a1.309,1.309,0,0,0-1.484,1.265c0,.891.891,1.213,2,1.652,1.265.5,2.569,1.149,2.569,2.814a2.74,2.74,0,0,1-3.008,2.724A2.8,2.8,0,0,1,99.985,109.8Z",
    transform: "translate(-86.804 -103.097)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M119.848,114.247a3.343,3.343,0,1,1,3.343,3.356A3.322,3.322,0,0,1,119.848,114.247Zm5.331,0a1.983,1.983,0,1,0-1.988,2.066A2.023,2.023,0,0,0,125.179,114.247Z",
    transform: "translate(-99.101 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M141.167,111.02h1.368v.775a2.258,2.258,0,0,1,1.9-.9,2.235,2.235,0,0,1,2.13,1.162,2.5,2.5,0,0,1,2.181-1.162,2.455,2.455,0,0,1,2.672,2.711v3.873H150.01v-3.782a1.427,1.427,0,0,0-1.5-1.6,1.534,1.534,0,0,0-1.536,1.743v3.64h-1.394v-3.847a1.378,1.378,0,0,0-1.458-1.536c-.9,0-1.575.607-1.575,1.794v3.588h-1.381Z",
    transform: "translate(-112.3 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M171.807,114.247a3.343,3.343,0,1,1,3.344,3.356A3.322,3.322,0,0,1,171.807,114.247Zm5.331,0a1.983,1.983,0,1,0-1.988,2.066A2.023,2.023,0,0,0,177.138,114.247Z",
    transform: "translate(-131.269 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M192.382,115.422h1.407v.026a.892.892,0,0,0,1.007.942c.593,0,.9-.31.9-.813,0-.529-.723-.671-1.485-.942-.813-.284-1.678-.71-1.678-1.9a1.926,1.926,0,0,1,2.168-1.846c1.369,0,2.259.723,2.259,1.988h-1.356v-.013a.768.768,0,0,0-.878-.839.716.716,0,0,0-.813.71c0,.491.723.646,1.471.93.814.3,1.652.723,1.652,1.9a2.054,2.054,0,0,1-2.272,2.04C193.285,117.6,192.382,116.855,192.382,115.422Z",
    transform: "translate(-144.007 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M217.531,107.937a4.821,4.821,0,0,1,4.892-4.84,4.748,4.748,0,0,1,4.583,3.472H225.5a3.245,3.245,0,0,0-3.124-2.117,3.479,3.479,0,0,0,0,6.957,3.243,3.243,0,0,0,3.085-2.04h1.536a4.839,4.839,0,0,1-9.462-1.433Z",
    transform: "translate(-159.577 -103.097)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M245.73,114.247a3.343,3.343,0,1,1,3.344,3.356A3.322,3.322,0,0,1,245.73,114.247Zm5.331,0a1.983,1.983,0,1,0-1.988,2.066A2.023,2.023,0,0,0,251.061,114.247Z",
    transform: "translate(-177.035 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M267.05,111.02h1.368v.775a2.259,2.259,0,0,1,1.9-.9,2.235,2.235,0,0,1,2.13,1.162,2.5,2.5,0,0,1,2.181-1.162A2.455,2.455,0,0,1,277.3,113.6v3.873h-1.407v-3.782a1.427,1.427,0,0,0-1.5-1.6,1.534,1.534,0,0,0-1.536,1.743v3.64h-1.394v-3.847a1.378,1.378,0,0,0-1.459-1.536c-.9,0-1.575.607-1.575,1.794v3.588H267.05Z",
    transform: "translate(-190.234 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M299.6,116.674v3.77h-1.368V111.02H299.6v.9a2.719,2.719,0,0,1,2.156-1.033,3.208,3.208,0,0,1,3.214,3.356,3.245,3.245,0,0,1-3.2,3.356A2.728,2.728,0,0,1,299.6,116.674Zm4-2.439a2.04,2.04,0,1,0-2.04,2.1A2.039,2.039,0,0,0,303.6,114.235Z",
    transform: "translate(-209.54 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M319.18,114.247a3.218,3.218,0,0,1,3.227-3.356,2.778,2.778,0,0,1,2.143.968v-.839h1.381v6.455h-1.381v-.891a2.745,2.745,0,0,1-2.156,1.02A3.247,3.247,0,0,1,319.18,114.247Zm5.447-.013a2.041,2.041,0,1,0-2.039,2.1A2.039,2.039,0,0,0,324.627,114.235Z",
    transform: "translate(-222.508 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M341.414,111.02h1.368v.839a2.411,2.411,0,0,1,1.988-.968,2.511,2.511,0,0,1,2.62,2.814v3.769H346v-3.653c0-1.059-.529-1.73-1.562-1.73a1.658,1.658,0,0,0-1.639,1.833v3.55h-1.381Z",
    transform: "translate(-236.273 -107.922)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M361.745,117.348l-2.672-6.119h1.485l1.884,4.479,1.781-4.479h1.459l-3.9,9.436h-1.42Z",
    transform: "translate(-247.206 -108.132)",
    fill: "#BEBEBE"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M0,1.532,8.323,13.394s.574-2.583,4.3-3.157L6.6,1.532Z",
    transform: "translate(0 -0.948)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M46.345,1.532,38.023,13.394s-.574-2.583-4.3-3.157l6.027-8.705Z",
    transform: "translate(-20.875 -0.948)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M46.628,52.7,38.306,40.838s-.574,2.583-4.3,3.157L40.028,52.7Z",
    transform: "translate(-21.05 -25.283)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M.283,52.7,8.606,40.838s.574,2.583,4.3,3.157L6.884,52.7Z",
    transform: "translate(-0.175 -25.283)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 3.139,
    cy: 3.139,
    r: 3.139,
    transform: "translate(9.597 10.896)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(24.958)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M77.5,0a9.91,9.91,0,0,1,6.735,2.1L81.826,5.74a6.957,6.957,0,0,0-4.248-1.492A5.066,5.066,0,0,0,73.1,6.5q-1.531,2.259-1.53,6.888,0,5.09,1.11,7.117a5.461,5.461,0,0,0,5.128,2.985,7.155,7.155,0,0,0,4.553-1.722l2.449,3.368a11.246,11.246,0,0,1-7.385,2.487,10.994,10.994,0,0,1-8.667-3.655,13.874,13.874,0,0,1-3.233-9.547,17.365,17.365,0,0,1,1.8-8.266A11.375,11.375,0,0,1,77.5,0Z",
    transform: "translate(-65.525)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M114.449,29.141A11.041,11.041,0,0,1,116.86,21.7a8,8,0,0,1,6.39-2.813,8.273,8.273,0,0,1,6.658,2.947,10.648,10.648,0,0,1,2.258,7.156,10.984,10.984,0,0,1-2.43,7.557,8.247,8.247,0,0,1-6.486,2.736,8.071,8.071,0,0,1-6.39-2.755A10.818,10.818,0,0,1,114.449,29.141Zm11.1-5.433a2.654,2.654,0,0,0-2.219-1.033,2.619,2.619,0,0,0-2.64,1.99,14.027,14.027,0,0,0-.536,4.362A13.563,13.563,0,0,0,120.82,34a2.543,2.543,0,0,0,2.583,1.57q3.176,0,3.176-6.62Q126.579,25.046,125.546,23.708Z",
    transform: "translate(-95.814 -11.692)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M165.207,23.483s6.346-4.5,10.21-4.5a5.592,5.592,0,0,1,2.946.785,3.953,3.953,0,0,1,1.761,2.047,8.28,8.28,0,0,1,.383,2.793V38.923h-5.051V26.181a5.787,5.787,0,0,0-.23-1.99,1.427,1.427,0,0,0-1.492-.88,5.615,5.615,0,0,0-3.559,1.76V38.923h-5.127S165.271,26.7,165.207,23.483Z",
    transform: "translate(-127.139 -11.755)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M213.553,23.483s6.346-4.5,10.21-4.5a5.591,5.591,0,0,1,2.946.785,3.952,3.952,0,0,1,1.761,2.047,8.291,8.291,0,0,1,.383,2.793V38.923H223.8V26.181a5.775,5.775,0,0,0-.23-1.99,1.427,1.427,0,0,0-1.492-.88,5.616,5.616,0,0,0-3.559,1.76V38.923h-5.127S213.617,26.7,213.553,23.483Z",
    transform: "translate(-157.071 -11.755)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M268.336,35.608a7.555,7.555,0,0,0,4.941-1.951l1.976,3.061a11.4,11.4,0,0,1-7.385,2.717,8.693,8.693,0,0,1-6.735-2.755,10.5,10.5,0,0,1-2.525-7.385q0-5.05,2.41-7.73a7.964,7.964,0,0,1,6.2-2.679,7.573,7.573,0,0,1,5.663,2.067q2.6,2.678,2.6,8.571v1.187h-11.25v.152Q264.233,35.608,268.336,35.608Zm-4.1-8.724v.076h5.931v-.23a5.578,5.578,0,0,0-.612-2.946,2.483,2.483,0,0,0-2.258-1.148Q264.232,22.636,264.233,26.884Z",
    transform: "translate(-185.063 -11.692)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M320.2,18.962a10.022,10.022,0,0,1,1.913,1.378l-2.487,3.367a4.738,4.738,0,0,0-3.1-1.53q-3.329,0-3.329,6.582,0,3.711.995,4.936a2.792,2.792,0,0,0,2.3,1.11,5.471,5.471,0,0,0,3.52-1.608l.307-.267,2.334,3.1a9.36,9.36,0,0,1-1.8,1.454,9.206,9.206,0,0,1-4.783,1.225,7.775,7.775,0,0,1-6.3-2.66q-2.237-2.659-2.238-7.443,0-6.35,4.018-9.068a8.457,8.457,0,0,1,4.86-1.454A8.361,8.361,0,0,1,320.2,18.962Z",
    transform: "translate(-215.353 -11.195)",
    fill: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M357.428,10.213h4.592l-1.3,3.405h-3.291v9.988a4.648,4.648,0,0,0,.46,2.506,2.055,2.055,0,0,0,1.76.632,7.663,7.663,0,0,0,1.836-.382l.651,3.061a10.953,10.953,0,0,1-4.171.881,6.964,6.964,0,0,1-3.387-.785,3.842,3.842,0,0,1-1.895-2.085,9.893,9.893,0,0,1-.344-3.024V10.289a39.868,39.868,0,0,1,.191-4.668l5.2-1.3A55.416,55.416,0,0,0,357.428,10.213Z",
    transform: "translate(-243.093 -2.675)",
    fill: "#BEBEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerXconnect);
export default __webpack_public_path__ + "static/media/partner_xconnect.2b49b2032e8d5db5066ea11105f81df6.svg";
export { ForwardRef as ReactComponent };